<section aria-labelledby="formacao-title">
  <div class="tela-formacoes" #scrollContainer (scroll)="onScroll()">
    <div class="lista-tipos">
      <span (click)="navegarParaTag('formacao')" tabindex="0" role="button" aria-label="Navegar para Formação">
        <img src="assets/studies/formacao.png" alt="Ícone Representando Ensino Superior" class="icon">
        {{ formacao }}
      </span>
      <span (click)="navegarParaTag('idiomas')" tabindex="0" role="button" aria-label="Navegar para Idiomas">
        <img src="assets/studies/idioma.png" alt="Ícone Representando Idiomas" class="icon">
        {{ idiomas }}
      </span>
      <span (click)="navegarParaTag('extra')" tabindex="0" role="button" aria-label="Navegar para Cursos Extras">
        <img src="assets/studies/extra.png" alt="Ícone Representando Cursos Extras" class="icon icon-extra">
        {{ extraCurso }}
      </span>
    </div>
    <div>
      <h4 id="formacao" class="formacao-titulo">{{ formacao }}</h4>
      <ul>
        <li>{{ superiorAtual }}</li>
        <li>{{ superiorAnterior }}</li>
      </ul>
      <h4 id="idiomas" class="formacao-titulo">{{ idiomas }}</h4>
      <ul>
        <li>{{ espanholNivel }}</li>
        <li>{{ inglesNivel }}</li>
      </ul>
    </div>
    <h4 id="extra" class="formacao-titulo">{{ extraCurso }}</h4>
    <div>
      <ul>
        <li>{{ extra1 }}</li>
        <li>{{ extra2 }}</li>
        <li>{{ extra3 }}</li>
        <li>{{ extra4 }}</li>
        <li>{{ extra5 }}</li>
        <li>{{ extra6 }}</li>
      </ul>
    </div>
  <app-container-botao [isScrollAtTop]="isScrollAtTop" (voltarHome)="onVoltarHome()" (scrollToTop)="scrollToTop()"></app-container-botao>
  </div>
</section>
